// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-employment-history.page.title': 'Employment Histories',
    'team-member-employment-history.page.search_results': 'Search Results',
    'team-member-employment-history.page.create.title': 'Create New Employment History',
    'team-member-employment-history.page.search.title': 'Find Employment Histories',
    'team-member-employment-history.page.edit.title': 'Edit Employment Record',
    'team-member-employment-history.page.view.title': 'View Employment History',
    'team-member-employment-history.page.all': 'All',

    'team-member-employment-history.button.cancel': 'Cancel',
    'team-member-employment-history.button.select': 'Select',
    'team-member-employment-history.button.find': 'Find Employment Histories',
    'team-member-employment-history.button.search': 'Apply',
    'team-member-employment-history.button.create': 'Save Employment History',
    'team-member-employment-history.button.new': 'New Employment History',
    'team-member-employment-history.button.save': 'Save Changes',
    'team-member-employment-history.button.delete': 'Permanently Delete',
    'team-member-employment-history.button.edit': 'Edit',
    'team-member-employment-history.button.restore': 'Restore',
    'team-member-employment-history.button.rehire': 'Rehire',
    'team-member-employment-history.button.remove': 'End Employment',

    'team-member-employment-history.placeholder.search': 'Search employment histories',

    'team-member-employment-history.link.create_first_team_member_employment_history': 'Click here to create your first employment history',
    'team-member-employment-history.link.team_member_employment_histories': ' Return to Employment Histories',
    'team-member-employment-history.link.retry': 'Click here to retry',

    'team-member-employment-history.checkbox.all': 'Check All',
    'team-member-employment-history.checkbox.actions_label': 'with selected',

    'team-member-employment-history.label.team_member_name': 'Team Member',
    'team-member-employment-history.label.from_date': 'From Date',
    'team-member-employment-history.label.thru_date': 'Thru Date',
    'team-member-employment-history.label.present': 'Present',

    'team-member-employment-history.sort.field_label': 'Field',
    'team-member-employment-history.sort.direction_label': 'Direction',
    'team-member-employment-history.sort.direction_ascending': 'Ascending',
    'team-member-employment-history.sort.direction_descending': 'Descending',

    'team-member-employment-history.modal.title.team_member_remove': 'End Member Employment',
    'team-member-employment-history.modal.title.team_member_employment_history_delete_permanently': 'Delete Employment History',
    'team-member-employment-history.modal.title.team_member_employment_history_restore': 'Restore Employment History',

    'team-member-employment-history.modal.message.team_member_remove': 'You are about to end employment for this team member.',
    'team-member-employment-history.modal.message.team_member_employment_history_delete_permanently': 'Are you sure that you want to permanently delete this employment history?',
    'team-member-employment-history.modal.message.team_member_employment_history_restore': 'Are you sure that you want to restore this employment history?',

    'team-member-employment-history.success.message.member_unemployed': 'Employment has ended for the selected member',
    'team-member-employment-history.success.message.team_member_employment_history_created': 'Team member successfully rehired',
    'team-member-employment-history.success.message.team_member_employment_history_updated': 'Your employment history has been updated',
    'team-member-employment-history.success.message.team_member_employment_history_restored': 'Your employment history has been restored | All selected employment histories were restored',
    'team-member-employment-history.success.message.team_member_employment_history_deleted': 'Your employment history has been permanently deleted | All selected employment histories were permanently deleted',

    'team-member-employment-history.error.message.team_member_employment_history_deleted': 'This employment history was already permanently deleted | These employment histories were already permanently deleted',
    'team-member-employment-history.error.message.team_member_employment_history_restored': 'This employment history was already restored | These employment histories were already restored',
    'team-member-employment-history.error.message.error_loading_page': 'Sorry, there was an error loading employment history.| Sorry, there was an error loading employment histories.',
};
